import { createFileRoute } from "@tanstack/react-router";

import { CommissionsPage } from "../../../../areas/seller/more/commissions/CommissionsPage";

export const Route = createFileRoute("/app/_seller/more/commissions")({
  component: CommissionsPage,
});
